module.exports = __webpack_public_path__ + "img/workplace(old).fa12cacf.png";